import { FiAlertCircle, FiCheckCircle } from 'react-icons/fi';

export default function RecoveryResults({ result }) {
    const data = result?.response?.data;
    if (!data || result.status === 'running' || result.status === 'error') return null;
    return <section className="command-recovery-results" aria-labelledby="recovery-result-title">
        <h3 id="recovery-result-title">Recovery results <span>Last {result.hours === 168 ? '7 days' : `${result.hours} hours`}</span></h3>
        <dl>{[['Orders checked', data.total_checked], ['Recovered', data.recovered], ['Still unresolved', data.still_failed], ['Errors', data.errors]].map(([label, value]) =>
            <div key={label}><dt>{label}</dt><dd>{value ?? '—'}</dd></div>)}</dl>
        {Number(data.total_checked) === 0 && <p>No failed EcoCash orders were found in this period.</p>}
        {data.details?.length > 0 && <details className="command-order-details"><summary>View {data.details.length} order {data.details.length === 1 ? 'result' : 'results'}</summary>
            <ul>{data.details.map((detail, index) => <li key={`${detail.order_number}-${index}`}>
                {detail.status === 'recovered' ? <FiCheckCircle aria-hidden="true" /> : <FiAlertCircle aria-hidden="true" />}
                <div><strong>{detail.order_number}</strong><span>{detail.status === 'recovered' ? `Recovered · ${detail.new_status}`
                    : detail.status === 'error' ? `Error · ${detail.error}`
                        : `${detail.status === 'confirmed_failed' ? 'Payment failed' : 'Status unresolved'} · ${detail.ecocash_status || 'No payment status returned'}`}</span></div>
            </li>)}</ul>
        </details>}
    </section>;
}
